import {BaseStoreItem} from '../BaseStoreItem.ts'
import {StoreConsumable, StoreItemCategory} from '../../entity_datas/StoreEnums.ts'
import {LobbyImage} from '@colonist/types'
import {type TranslationObject, type TranslationArrayKeys} from '@colonist/i18n'

export class SIUsernameChange extends BaseStoreItem {
    category = StoreItemCategory.Consumable
    type = StoreConsumable.UsernameChange
    name: TranslationObject = {key: 'strings:storePage.consumables.usernameChange.title'}
    description: TranslationArrayKeys = 'strings:storePage.consumables.usernameChange.description'
    price = 1300
    image = LobbyImage.Guest
}
